import { useEffect } from "react";

const FOCUSABLE = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** Global Tab trap — keeps keyboard focus inside the topmost open modal dialog. */
export function FocusTrap() {
    useEffect(() => {
        const onKey = (e) => {
            if (e.key !== "Tab") return;
            const dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"], [role="alertdialog"][aria-modal="true"]');
            if (!dialogs.length) return;
            const dialog = dialogs[dialogs.length - 1];
            const focusables = [...dialog.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);
            if (!focusables.length) return;
            const first = focusables[0];
            const last = focusables[focusables.length - 1];
            const active = document.activeElement;
            if (!dialog.contains(active)) {
                e.preventDefault();
                first.focus();
            } else if (!e.shiftKey && active === last) {
                e.preventDefault();
                first.focus();
            } else if (e.shiftKey && active === first) {
                e.preventDefault();
                last.focus();
            }
        };
        window.addEventListener("keydown", onKey, true);
        return () => window.removeEventListener("keydown", onKey, true);
    }, []);
    return null;
}
